import firebase from 'firebase/app'
import 'firebase/auth';
import 'firebase/firestore';

//to switch database to use, just change variable name to config
//do not forget to lock then names of other variables eg to configBLABLA

//SZYMON
const configSZY = {
  apiKey: 'AIzaSyBQX96_qp6jey3VT6wpsNog6cU7WtRMJcM',
  authDomain: 'exsellance-a4ce4.firebaseapp.com',
  databaseURL: 'https://exsellance-a4ce4.firebaseio.com',
  projectId: 'exsellance-a4ce4',
  storageBucket: 'gs://exsellance-a4ce4.appspot.com',
  messagingSenderId: '646119254210'
}

//PROD
const config = {
  apiKey: "AIzaSyD_uPoPyDgB-M73e1I3ACdBgoBkGerXdzM",
  authDomain: "exsellance-2e8e9.firebaseapp.com",
  databaseURL: "https://exsellance-2e8e9.firebaseio.com",
  projectId: "exsellance-2e8e9",
  storageBucket: "exsellance-2e8e9.appspot.com",
  messagingSenderId: "916199623145",
  appId: "1:916199623145:web:e0304b6ed77ed3aeeba378"
}

firebase.initializeApp(config)

export default firebase
